module.exports = __webpack_public_path__ + "static/boy_2-18577b045eec0dbb8cff3e3118b04186.svg";